import React, {useId, useState} from 'react'
import {Button, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap';
import { CalendarEvent } from './types/CalendarEvent';
import ChangeEventDate from "./change-event-date";
import PdfModal from "../modals/pdf-modal";
import {API_URL} from "../../api";

type Props = {
    event: CalendarEvent
    update: () => void
}

const EventModal = (props: Props) => {
    const [show, setShow] = useState(false);
    const event = new CalendarEvent(props.event);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const resume = event?.candidateVacancyStep?.resume
    const id = useId()
    return <>
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id={`tooltip-${id}`}>
                    <div>
                        {'Этап: ' + event.summary}
                    </div>
                    <div>
                        {'Вакансия: ' + event?.candidateVacancyStep?.step?.vacancy?.position || ""}
                    </div>
                </Tooltip>
            }
        >
            <div className="event shadow-sm"
                onClick={handleShow}
                style={{ ...event.getPosition() }}
            >
                <p>{event.summary}</p>
            </div>
        </OverlayTrigger>

        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {'Этап: ' + event.summary}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={'flex flex-col gap-2'} >
                <p className={'text-lg'}>{'Вакансия: ' + event?.candidateVacancyStep?.step?.vacancy?.position || ''}</p>
                <p className={'text-lg'}>{event.description}</p>
                <div className="d-flex" style={{ gap: 10 }}>
                    <i className="bi bi-clock"></i>
                    <p>{event.getDateHoursString('start')} - {event.getDateHoursString('end')}</p>
                </div>
                <div className={'flex gap-4 items-center'}>
                    <label>Резюме:</label>
                    {resume && (
                      <>
                          <PdfModal fileId={resume?.file}/>
                          <a key={resume?.id} href={`${API_URL}${resume?.file}`} download={true} target='_blank' rel="noreferrer">
                              <i className="fa-solid fa-file-arrow-down text-success" style={{ fontSize: '22px' }}></i>
                          </a>
                      </>
                    )}
                </div>

                <label>Участники</label>
                <ul className="list-group mb-3">
                    {
                        event.attendees.map((attendee) => {
                            return <li key={attendee} className="list-group-item">{attendee}</li>
                        })
                    }
                </ul>

                <ChangeEventDate event={event} update={props.update} />

                {/*<ChangeMeetingDateModal*/}
                {/*  step={incompleteItem}*/}
                {/*  candidate={props.candidate}*/}
                {/*  update={update}*/}
                {/*  vacancyId={props.vacancyId}*/}
                {/*/>*/}
            </Modal.Body>
        </Modal>
    </>
}

export default EventModal